import React from 'react';

import Row from "react-bootstrap/Row";


const Temp= (   ) => {


    return (
        <>

            <Row className="mb-3 text-start">
                <h4 className="text-center">
        Registration opens Tuesday, September 9th.<br/>
Please visit again after that time.<br/>
We look forward to working with you!
  
        </h4>
            </Row>
            </>
            );
}



            export default Temp;
